import router from '@/router';
import axios from 'axios';
import appToaster from './app-toaster';
import storeService from './store-service';

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: process.env.NODE_ENV === "development" ? 60000 : 10000,
    headers: {
        Accept: 'application/json'
    }
});

httpClient.interceptors.response.use(response => {
    return response;
}, error => {
    if (error?.request?.status === 0) {
        appToaster.error("Could not connect to server");
    } if (error?.request?.status === 401) {
        storeService.clearUser();
        router.push({ name: "login", query:{ redirectUrl: router.currentRoute?.value?.path } });
        return Promise.reject(error);
    } else {
        const errors = error?.response?.data?.errors;
        appToaster.error(errors && errors.length ? errors[0] : null);
    }
    return Promise.reject(error);
});

// ToDo - Interceptor (error handling)

export default httpClient;